import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IdpDemoCodeResponeModel } from './idp-demo-code-respone.model';

@Injectable({
    providedIn: 'root'
})
// ToDo: move into correct place and rename from demo
export class IdpDemoService {

    constructor(private httpClient: HttpClient) { }

    public getHandOffToken(): Observable<IdpDemoCodeResponeModel> {
        return this.httpClient.post<IdpDemoCodeResponeModel>(`${environment.idpApi}/handoff`, null);
    }

    public openStaffToolWithHandoff(handoffCode: string, userId: number): void {
        let handOffUrl = `${environment.staffToolUrl}/login/handoff?code=${encodeURIComponent(handoffCode)}&userId=${userId}`;
        window.location.href = handOffUrl;
    }
}
